/**
 * Whether a cart-conditional block should be visible, shared by the Liquid-rendered initial state
 * and the runtime element so the two cannot disagree.
 *
 * Ported from Basecamp's conditional-cart block. Both unknown-input cases fail *open*: a block the
 * code cannot classify is shown rather than silently swallowed, because a merchant is far more
 * likely to notice content that should be hidden than content that never appears.
 */

/**
 * The conditions the cart-conditional blocks offer. `always` is Basecamp's two plus an explicit
 * name for the fail-open branch, so a block that should never be gated says so rather than
 * relying on an unrecognised value.
 */
export const CART_CONDITIONS = ['always', 'empty', 'not_empty']

/**
 * @param {string} condition One of CART_CONDITIONS. Anything else shows.
 * @param {number} minimumCount Minimum items for `not_empty`. Invalid or below 1 is treated as 1.
 * @param {number} itemCount The cart's current item count. Missing counts as an empty cart.
 * @returns {boolean}
 */
export const shouldShowForCart = (condition, minimumCount, itemCount) => {
  const items = Number.isFinite(Number(itemCount)) ? Number(itemCount) : 0
  const minimum = Number.isFinite(Number(minimumCount)) && Number(minimumCount) >= 1 ? Number(minimumCount) : 1

  if (condition === 'always') return true
  if (condition === 'empty') return items === 0
  if (condition === 'not_empty') return items >= minimum
  return true
}
